import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessStepRecordingDisplaySchema } from '../../entities/process-step-recording/process-step-recording.schema';
/**
 * Stop Process Step Recording Request Schema
 * POST /api/v2/process-step-recording/:id/stop-recording
 */ export const StopProcessStepRecordingRequestSchema = z.void();
/**
 * Stop Process Step Recording Response Schema
 * Returns the recording in the new pending_finalization state so the review
 * dialog can render immediately without an extra fetch.
 */ export const StopProcessStepRecordingResponseSchema = z.object({
    processStepRecording: ProcessStepRecordingDisplaySchema.nullable()
});
export const StopProcessStepRecordingErrorSchema = BaseErrorSchema;

//# sourceMappingURL=stop-process-step-recording.schema.js.map